/**
 * Determines whether the first object contains every entry in the second object.
 * @param object1 The object that may be a superset
 * @param object2 The object that may be contained within another object
 * @returns True if object1 contains all the entries from object2 or false otherwise
 */
export const hasEntries = (object1, object2) => {
    const anItemIsAnObject = typeof object1 === "object" || typeof object2 === "object";
    let isEqual = anItemIsAnObject && object1 === object2;
    if (!isEqual && anItemIsAnObject) {
        const object1Keys = Object.keys(object1);
        const object2Keys = Object.keys(object2);
        if (object1Keys.length >= object2Keys.length) {
            isEqual = object2Keys.every((key) => {
                const object1Value = object1[key];
                const object2Value = object2[key];
                let itemIsEqual;
                if (typeof object1Value === "object" &&
                    object1Value !== null &&
                    typeof object2Value === "object" &&
                    object2Value !== null) {
                    itemIsEqual = hasEntries(object1[key], object2[key]);
                }
                else {
                    itemIsEqual = object1[key] === object2[key];
                }
                return itemIsEqual;
            });
        }
    }
    return isEqual;
};
